// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/layouts/SaasLayout.tsx
// Version: v1.0.0
// Schlankes Layout für SaaS-Seiten (Pricing, Signup, Verify) — kein CMS, kein Reveal

import { Outlet } from "react-router-dom";

const SaasLayout = () => {
  return (
    <div className="min-h-screen w-full bg-white">
      <Outlet />
    </div>
  );
};

export default SaasLayout;
